<section class="container">
    <div class="login-section">
        <div class="login-header">
            <img src="assets/icons/seller-logo.png" class="app-logo" alt="app-logo" />
        </div>
        <div class="welcome-part">
            <h4 class="welcome-title">أنشئ حسابك</h4>
            <p class="welcome-paragraph">أدخل التفاصيل لإنشاء حسابك</p>
        </div>
        <div class="credentials-part col-md-6">
            <form [formGroup]="form" (ngSubmit)="register()">
                <!-- USER NAME -->
                <div class="d-flex flex-column gap-2 mb-3">
                    <label for="username">إسم المستخدم</label>
                    <input
                        formControlName="name"
                        autocomplete="off"
                        pInputText
                        id="username"
                        class="p-inputtext-sm"
                        aria-describedby="username-help" />
                </div>
                <!-- USER EMAIL -->
                <div class="d-flex flex-column gap-2 mb-4">
                    <label for="email">البريد الإلكتروني</label>
                    <input
                        formControlName="email"
                        pInputText
                        id="email"
                        autocomplete="off"
                        type="email"
                        class="p-inputtext-sm"
                        aria-describedby="username-help" />
                </div>
                <div class="d-flex flex-column gap-2 mb-4">
                    <label for="phoneNumber">رقم الجوال</label>
                    <input
                        formControlName="phoneNumber"
                        pTooltip="سيتم ارسال التقارير اليومية على الواتس اب"
                        pInputText
                        id="phoneNumber"
                        autocomplete="off"
                        placeholder="5XXXXXXXX"
                        class="p-inputtext-sm"
                        aria-describedby="phoneNumber-help" />
                </div>
                <!-- USER PASSWORD -->
                <div class="d-flex flex-column gap-2 mb-4">
                    <label for="password">كلمة المرور</label>
                    <input
                        formControlName="password"
                        pInputText
                        id="password"
                        autocomplete="off"
                        type="password"
                        class="p-inputtext-sm"
                        aria-describedby="username-help" />
                </div>
                <div class="submit-form full-width">
                    <p-button
                        [disabled]="form.invalid || registerInProgress"
                        type="submit"
                        label="تسجيل"
                        class="w-100"
                        [icon]="registerInProgress ? 'pi pi-spin pi-spinner' : ''"></p-button>
                </div>
            </form>
            <!-- DONT HAVE ACCOUNT -->
            <div class="register-redirection">
                <small>لديك حساب؟ <a class="m-1 text-primary-600" routerLink="/auth/login">تسجيل الدخول</a></small>
            </div>
        </div>
    </div>
</section>
<p-toast position="top-right"></p-toast>
